import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import {
  EPackingSlipColumns,
  EPackingSlipPageOrientationOptions,
  EPackingSlipPageSizeOptions,
  EPackingSlipShowKitOptions,
} from '../../interfaces';

@Component({
  selector: 'lum-packing-slip-config-dialog',
  templateUrl: './packing-slip-config-dialog.component.html',
  styleUrls: ['./packing-slip-config-dialog.component.scss'],
})
export class PackingSlipConfigDialogComponent implements OnInit {
  form :UntypedFormGroup;

  EPackingSlipColumns = EPackingSlipColumns;
  EPackingSlipShowKitOptions = EPackingSlipShowKitOptions;
  EPackingSlipPageSizeOptions = EPackingSlipPageSizeOptions;
  EPackingSlipPageOrientationOptions = EPackingSlipPageOrientationOptions;

  columns = [
    {
      label: 'Line No',
      value: EPackingSlipColumns.LINE_NO,
      default: true,
    },
    {
      label: 'Product Photo',
      value: EPackingSlipColumns.PRODUCT_PHOTO,
      default: false,
    },
    {
      label: 'SKU',
      value: EPackingSlipColumns.SKUS,
      default: true,
    },
    {
      label: 'UPC',
      value: EPackingSlipColumns.UPC,
      default: true,
    },
    {
      label: 'Product',
      value: EPackingSlipColumns.PRODUCTS,
      default: true,
    },
    {
      label: 'Description',
      value: EPackingSlipColumns.DESCRIPTION,
      default: true,
    },
    {
      label: 'Ordered Quantity',
      value: EPackingSlipColumns.ORDERED_QUANTITY,
      default: true,
    },
    {
      label: 'Ordered Unit',
      value: EPackingSlipColumns.ORDERED_UNIT,
      default: true,
    },
    {
      label: 'Base Quantity',
      value: EPackingSlipColumns.BASE_QUANTITY,
      default: false,
    },
    {
      label: 'Base Unit',
      value: EPackingSlipColumns.BASE_UNIT,
      default: false,
    },
    {
      label: 'Warehouse',
      value: EPackingSlipColumns.WAREHOUSE,
      default: false,
    },
    {
      label: 'Location',
      value: EPackingSlipColumns.LOCATION,
      default: false,
    },
  ];

  constructor(
    public dialogRef :MatDialogRef<PackingSlipConfigDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data :{},
    private formBuilder :UntypedFormBuilder,
  ) {}

  ngOnInit() :void {
    this.form = this.formBuilder.group({
      pageSize: [EPackingSlipPageSizeOptions.A4, [Validators.required]],
      pageOrientation: [
        EPackingSlipPageOrientationOptions.PORTRAIT,
        [Validators.required],
      ],
      showKitOption: [
        EPackingSlipShowKitOptions.KIT_COMPONENTS_ONLY,
        [Validators.required],
      ],
      showCustomerNotesOption: [false],
    });

    this.initColumn();
  }

  private initColumn() {
    this.columns.map((column) => {
      this.form.addControl(column.value, this.formBuilder.control(column.default));
    });
  }

  onExportPackingSlip() {
    const exportColumns :string[] = [];
    this.columns.forEach((col :any) => {
      if (this.form.value[col.value]) {
        exportColumns.push(col.value);
      }
    });
    if (!exportColumns.length) return;
    this.dialogRef.close({
      showKitOption: this.form.value.showKitOption,
      columns: exportColumns.join(','),
      pageSize: this.form.value.pageSize,
      pageOrientation: this.form.value.pageOrientation,
      exportType: 'pdf',
      showCustomerNotesOption: this.form.value.showCustomerNotesOption,
    });
  }

  closeDialog() :void {
    this.dialogRef.close(false);
  }
}
